import styled from "styled-components"
import { animated } from "@react-spring/web"

export const UI = styled(animated.div)`
  -webkit-touch-callout: none;
  border-radius: 1px;
  overflow: hidden;
  z-index: 1000;
  position: absolute;
  top: 50%;
  left: ${props => props.left}px;
  transform: translate(0, -50%);
  width: 27vw;
  background-color: #d0d0d0;
  height: 73vh;
  opacity: 0.94;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`

export const ClearBlockSelection = styled.div`
  display: flex;
  justify-content: center;
  user-select: none;
  cursor: pointer;
  left: 0;
  bottom: 0;
  z-index: 100;
  font-size: 2rem;
  color: purple;
`

export const FilterButtonsContainer = styled.div`
  overflow: hidden;
  -webkit-touch-callout: none;
  display: flex;
  padding-top: 5%;
  flex: 4;
  flex-direction: column;
  text-align: center;
`

export const FilterButtonStrip = styled.div`
  overflow: hidden;
  /* border: black solid 2px; */
  -webkit-touch-callout: none;
  display: flex;
  justify-content: flex-start;
  flex-basis: 70px;
  padding-left: 5%;
  padding-right: 5%;
  margin: 0.6%;
  /* padding-top: 1%; */
  /* padding-bottom: 1%; */
`

export const FilterButtonContainer = styled.div`
  overflow: hidden;
  /* border: black solid 2px; */
  /* flex-basis: 70px; */
  -webkit-touch-callout: none;
  /* flex: 1; */
  /* height: 60px; */
  margin: 1%;
  width: 70px;
  cursor: pointer;
  user-select: none;
  /* border-radius: 100%; */
`

export const BlockStrip = styled.div`
  border: red solid 2px;

  /* border: orange solid 2px; */
  overflow: hidden;
  -webkit-touch-callout: none;
  display: flex;
  flex: 1;
  background-color: #e3e3e3;
  justify-content: space-between;
  padding-top: 4%;
  padding-bottom: 2%;
  padding-left: 20%;
  padding-right: 20%;
  font-size: 1.2rem;
  color: #e8e8e8;
  user-select: none;
  align-items: center;
`
export const ControlsStrip = styled.div`
  font-family: AzoSans-Regular;
  letter-spacing: 0.1em;
  overflow: hidden;
  -webkit-touch-callout: none;
  display: flex;
  flex: 2;
  background-color: #5f7774;
  justify-content: space-between;
  padding-left: 5%;
  padding-right: 5%;
  font-size: 0.75rem;
  color: #e8e8e8;
  user-select: none;

  align-items: center;
`

export const AvailableStrip = styled.div`
  overflow: hidden;
  -webkit-touch-callout: none;
  display: flex;
  flex: 1;
  user-select: none;
  background-color: #381a4f;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 1rem;
  color: #e8e8e8;
`

export const BuildingDiagramLayout = styled.div`
  /* border: red solid 2px; */
  margin: 2%;
  display: flex;
  padding: 0;
  height: 100%;
  /* max-width: 80%; */
  justify-content: center;
  align-items: center;
  color: #381a4f;
  text-align: center;
  svg {
    width: 100%;
  }
`

export const BuildingDiagramTitle = styled.div`
  display: flex;
  padding: 0;
  width: 80%;
  justify-content: space-between;
  align-items: center;
  p {
    margin: 0;
    padding: 0;
    color: #5f7774;
    font-size: 0.9vw;
  }
`

export const NumberColumn = styled.div`
  display: flex;
  flex-direction: ${props => (props.reverse ? "column-reverse" : "column")};
  padding: 5%;
  justify-content: space-around;
  justify-content: inherit;

  align-items: space-around;
  color: #e8e8e8;

  text-align: center;
  p {
    /* margin: 2%; */
    padding-top: 9px;
    padding-bottom: 9px;
    transform: translate(0, 70%);
    margin: 0%;
    flex: 1;
    font-weight: 400;
    color: #e8e8e8;
    line-height: 0%;
    font-size: 0.75rem;
  }
`

export const BuildingDiagramContainer = styled.div`
  overflow: hidden;
  -webkit-touch-callout: none;
  padding: 2%;
  padding-bottom: 10%;
  display: flex;
  /* flex-direction: column; */
  flex-basis: max-content;
  align-items: center;
  justify-content: center;
  flex: 12;
  margin: 0;
  background-repeat: no-repeat;
  background-size: auto;
`
